<template>
    <div :class="$style['pt-system-customer-form']" v-loading="detail_loading">
        <pt-system-customer-with-data :isEdit="isEdit" :userLogin="userLogin" ref="form" @submitLoading="submitLoading" @detailLoading="detailLoading"></pt-system-customer-with-data>
        <div class="button-div">
            <el-button type="primary" @click="submit" :loading="loading">保存</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
        </div>
    </div>
</template>
<script>
import ptSystemCustomerWithData from './withData'
export default {
  components: {
    ptSystemCustomerWithData
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    userLogin: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      detail_loading: false
    }
  },
  methods: {
    detailLoading (val) {
      this.detailLoading = val
    },
    submitLoading (val) {
      this.loading = val
    },
    submit () {
      this.$refs.form.submit()
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>
<style module lang="less">
.pt-system-customer-form{
}
</style>
